import { Modal, notification } from 'antd'
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import * as yup from 'yup';
import axiosInstance from '../../../../../Services/axiosCommon';
import { NuInput, NuSelect } from '../../../../../Components/Utils/Input';
import { CancelButton, SubmitButton } from '../../../../../Components/Utils/Buttons';
import FormikSelectTwo from '../../../../../Components/Utils/Select';
import useFetchMataData from '../../../../../Components/Hooks/useFetchMataData';
import { useParams } from 'react-router-dom';
import UseDropDownPro from '../../../../../Components/Hooks/useProDD';


function EditSubItemsBOQ({open, getData, onCancel, data,id,estimationId ,Unit,Activity}) {
  const [api, contextHolder] = notification.useNotification();
  const [isLoading,setIsLoading] = useState(false);
//   const { value: Unit } = useFetchMataData(
//     `/dropdown/dropdown-details/`,
//     "Unit_item"
//   );
//   const {officeId}=useParams();
// const { data: Activity } = UseDropDownPro(`/Activity/${officeId}/drop-down`);

  const [createNew, setCreateNew] = useState({
    item: "",
    unit: "",
    quantity: "",
    unitPrice: "",
    totalPrice: "",
  });
  useEffect(() => {
    data&&setCreateNew({
    item: data?.item || "",
    unit: data?.unit || "",
    quantity: data?.quantity || "",
    unitPrice: data?.unitPrice || "",
    totalPrice: data?.totalPrice || "",
    estimationId: data?.estimationId || "",
    IT_Id: data?.IT_Id || ""
    })
  },[data])
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema:yup.object({
       item:yup.string().required("Item Name is Requried")
    }),
    onSubmit: (value,{resetForm}) => {
      axiosInstance.put(`/BOQ/update/${estimationId}/${id}/${data?.id}`, value)
      .then((res) => {
          console.log("res",res.data.status);
          if (res.data.status) {
            getData(id);
            resetForm();
            api.success({
              message: `BOQ Item Update successfully`,
              description: res?.data?.msg || "Added In The Activity",
              placement: "bottomRight",
            });
            onCancel();
          } else {
            api.error({
              message: `BOQ Item Upadate failed`,
              description: res?.data?.msg || "Network error",
              placement: "bottomRight",
            });
          }
        })
        .catch((err) => {
          api.error({
            message: `failed`,
            description: err?.data?.msg || "Sever error (or) Network error",
            placement: "bottomRight",
          });
        });
    },
  });
  useEffect(() => {
    const totalPrice = formik?.values?.quantity * formik?.values?.unitPrice
    formik.setFieldValue("totalPrice", totalPrice);
  }, [formik?.values?.quantity,formik?.values?.unitPrice]);
  return (
    <>
    {contextHolder}
    <Modal
      open={open}
      title={"Edit BOQ Item"}
      width={"50%"}
      className="my-modal"
      centered
      footer={[]}
      onCancel={onCancel}
    >
    <form onSubmit={formik.handleSubmit} >
      <div className=" w-full flex flex-wrap">
      <FormikSelectTwo
              type="text"
              label="Item "
              placeholder="Choose"
              Options={Activity}
              formik={formik}
              name="item"
              isRequired={true}

              width="w-full "
                     />
        <FormikSelectTwo
              type="text"
              label="Unit"
              placeholder="Choose"
              Options={Unit || []}
              formik={formik}
              name="unit"
              width="w-full md:w-1/2"
              
                     />
           <NuInput
            type="number"
              label="Quantity"
              placeholder="Quantity"
              formik={formik}
              name="quantity"
              width="w-full md:w-1/2"
            />
            <NuInput
             type="number"
              label="Unit Price"
              placeholder="Unit Price"
              formik={formik}
              name="unitPrice"
              width="w-full md:w-1/2"
            />
            <NuInput
             type="number"
              label="Total Price"
              placeholder="Total Price"
              formik={formik}
              name="totalPrice"
              width="w-full md:w-1/2"
              disabled={true}

            />
            <div className="w-full flex justify-end item-end float-right mx-auto md:mx-0 gap-2 mt-2 md:mr-4">
              <CancelButton handleClick={onCancel} />
              <SubmitButton isLoading={isLoading} />
            </div>
      </div>
      </form>
    </Modal>
    </>
  )
}

export default EditSubItemsBOQ